// The AI SDK decodes its event stream with TextDecoderStream, which Safari only
// gained in 16.4. Without this an older browser loses the whole chat reply.
class TextDecoderStreamPolyfill implements TransformStream<Uint8Array, string> {
	readonly readable: ReadableStream<string>
	readonly writable: WritableStream<Uint8Array>
	readonly encoding: string
	readonly fatal: boolean
	readonly ignoreBOM: boolean

	constructor(label = "utf-8", options: TextDecoderOptions = {}) {
		const decoder = new TextDecoder(label, options)
		const transform = new TransformStream<Uint8Array, string>({
			transform(chunk, controller) {
				const text = decoder.decode(chunk, { stream: true })
				if (text) controller.enqueue(text)
			},
			flush(controller) {
				const text = decoder.decode()
				if (text) controller.enqueue(text)
			},
		})

		this.readable = transform.readable
		this.writable = transform.writable
		this.encoding = decoder.encoding
		this.fatal = decoder.fatal
		this.ignoreBOM = decoder.ignoreBOM
	}
}

export function installTextDecoderStreamPolyfill(): void {
	if (typeof globalThis === "undefined") return
	if ("TextDecoderStream" in globalThis) return
	if (typeof TransformStream === "undefined") return

	Object.defineProperty(globalThis, "TextDecoderStream", {
		value: TextDecoderStreamPolyfill,
		configurable: true,
		writable: true,
	})
}
